/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApproveShopifyRequest
 */
export interface ApproveShopifyRequest {
  /**
   *
   * @type {string}
   * @memberof ApproveShopifyRequest
   */
  companyId: string;
}

/**
 * Check if a given object implements the ApproveShopifyRequest interface.
 */
export function instanceOfApproveShopifyRequest(
  value: object,
): value is ApproveShopifyRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  return true;
}

export function ApproveShopifyRequestFromJSON(
  json: any,
): ApproveShopifyRequest {
  return ApproveShopifyRequestFromJSONTyped(json, false);
}

export function ApproveShopifyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApproveShopifyRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
  };
}

export function ApproveShopifyRequestToJSON(json: any): ApproveShopifyRequest {
  return ApproveShopifyRequestToJSONTyped(json, false);
}

export function ApproveShopifyRequestToJSONTyped(
  value?: ApproveShopifyRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
  };
}
